import ServiceBase from './ServiceBase';

export default class PledgeService extends ServiceBase {
    constructor($http) {
        super($http);
    }

    saveCartShippingModel(projectID, shippingModelID) {
        return this.request('post', 'orderShipping/saveCartShippingModel', { projectID, shippingModelID });
    }

}